import type { ClaimGoogleTransLang, StreamStatus } from '@/domains/claim-charting/types/enum';
import type { TokenUsage } from './get-claim-feature-api';
import type { PsHttpSSE } from '@patsnap-utils/sse';

interface ClaimItem {
    name: string;
    separates: string[];
    indep_claim?: boolean;
}

export interface ApiGetClaimCompareResultRequest {
    claim_patent: string;
    desc_patent: string;
    claim_lang: string;
    separate_claims: ClaimItem[];
}

export interface CompareItem {
    claim_feature: string;
    compare_feature: string;
    is_public: string;
    reason: string;
}

export interface CompareItems {
    name: string;
    separate_compare: CompareItem[];
    indep_claim?: boolean;
}

export interface CompareFeatureContent {
    desc_lang: ClaimGoogleTransLang;
    separate_compares: CompareItems[];
}

export interface ApiGetClaimCompareResultResponse {
    status: StreamStatus;
    token_usage: TokenUsage;
    content: CompareFeatureContent;
}

export const GetClaimCompareResult = Symbol.for('GetClaimCompareResult');

export interface GetClaimCompareResult {
    getClaimCompareResult(request: ApiGetClaimCompareResultRequest): PsHttpSSE<ApiGetClaimCompareResultResponse>;
}
